import { environment } from 'environments/environment.base';
import { TransactionPrivate } from '../resources/transaction-private';
import { BLUE_COLOR, IStateDetails, stateDetails } from './state-public-models';

export class StatePublicHelper {
    private stateDetails: { [key: string]: IStateDetails } = stateDetails;
    private specialStateDetail: IStateDetails = {
        title: 'Verificando pagos',
        description: 'El pedido requiere la aprobación manual de un operador',
        color: BLUE_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/11.png'
    };
    private stateDefault: IStateDetails = {
        title: '',
        description: '',
        color: '#706F6F',
        icon: ''
    };

    public getStateDetail(state: number | string, transaction?: TransactionPrivate | null): IStateDetails {
        if (transaction && transaction.attributes.mark_as_send && Number(state) === 11) {
            return this.specialStateDetail;
        }

        return this.stateDetails[state.toString()] ?? this.stateDefault;
    }
}
